import { StyledToggle } from '@/components/styles'

export default function MenuToggle({ isOpen, ...props }) {
  return (
    <StyledToggle {...props}>
      <StyledToggle.Inner isOpen={isOpen} />
    </StyledToggle>
  )
}
